export const footerNav: {
  head: string;
  links: {
    name: string;
    path: string;
  }[];
}[] = [
  {
    head: "Vehicle",
    links: [
      {
        name: "Tesla",
        path: "/vehicles",
      },
      {
        name: "BMW",
        path: "/vehicles",
      },
      {
        name: "Toyota",
        path: "/vehicles",
      },
      {
        name: "Porsche",
        path: "/vehicles",
      },
      {
        name: "Chevrolet",
        path: "/vehicles",
      },
      {
        name: "etc",
        path: "/vehicles",
      },
    ],
  },
  {
    head: "Ecomoto",
    links: [
      {
        name: "About",
        path: "/about",
      },
      {
        name: "Team",
        path: "/team",
      },
      {
        name: "Policies",
        path: "/policies/terms-of-service",
      },
    ],
  },
  {
    head: "Explore",
    links: [
      {
        name: "Book a car",
        path: "/vehicles",
      },
      {
        name: "Register your vehicle",
        path: "/host",
      },
      {
        name: "Privacy policy",
        path: "/policies/privacy-policy",
      },
    ],
  },
  // {
  //   head: "Locations",
  //   links: ["Miami", "Jacksonville", "Tampa", "Miami Beach", "Naples, FL"],
  // },
  {
    head: "Contact",
    links: [
      {
        name: "Contact us",
        path: "/contact",
      },
      {
        name: "Support",
        path: "/support",
      },
      {
        name: "FAQs",
        path: "/faqs",
      },
    ],
  },
];
